<div class="button-container" [style.width]="width" [ngClass]="{disabled}">
  <div class="button-action" (click)="onButtonClick()">
    <div class="button-icon" [style.background-image]="icon | imgSrcToBackground"></div>
    <span class="button-label secondary">{{ label | translate }}</span>
  </div>
</div>
